import { render } from "./ProfileSettingForm.vue?vue&type=template&id=015b88c2"
import script from "./ProfileSettingForm.vue?vue&type=script&lang=js"
export * from "./ProfileSettingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__